import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	menuTitle: {
		id: 'issue-navigator-filters-menu.FiltersMenu.messages.menu-title',
		defaultMessage: 'Saved filters',
		description: 'Title for the saved filters menu in the project issue navigator.',
	},
	filtersMenuLabel: {
		id: 'issue-navigator-filters-menu.FiltersMenu.messages.updated-recently.filters-menu-label',
		defaultMessage: 'Saved filters menu',
		description: 'Accessible label for the saved filters menu in list view',
	},
	failedToLoadSavedFilters: {
		id: 'issue-navigator-filters-menu.FiltersMenu.messages.failed-to-load-saved-filters',
		defaultMessage: 'Couldn’t load saved filters',
		description: 'The text for when an error occurs when loading the saved filters menu',
	},
});
